<template>
  <div class="info-container">
    <div class="info-border">
      <mt-cell
        title="姓名">
        <p>{{ name }}</p>
      </mt-cell>
    </div>
    <div class="info-border">
      <mt-cell
        title="性别">
        <p>{{ gender }}</p>
      </mt-cell>
    </div>
    <div class="info-border">
      <mt-cell
        title="证件类型">
        <p>{{ documentType }}</p>
      </mt-cell>
    </div>
    <div class="info-border">
      <mt-cell
        title="证件号">
        <p>{{ idNumber }}</p>
      </mt-cell>
    </div>
    <div class="info-border">
      <mt-cell
        title="手机">
        <p>{{ phone }}</p>
      </mt-cell>
    </div>
    <div class="info-border">
      <mt-cell
        title="就诊卡号">
        <p>{{ card }}</p>
      </mt-cell>
    </div>
    <div>
      <mt-cell
        title="所属医院">
        <p>{{ hospital }}</p>
      </mt-cell>
    </div>
    <div style="margin:30px 10px;">
      <mt-button
        type="primary"
        size="large"
        @click="unbindCard">解绑就诊卡</mt-button>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';

export default {
  name: 'PersonalData',
  data() {
    return {
      name: '',
      gender: '',
      documentType: '二代身份证',
      idNumber: '',
      phone: '',
      card: '',
      hospital: '',
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    // 获取就诊卡信息
    async getInfo() {
      const hospitalId = this.$route.query.hospital;
      const { id } = this.$route.query;
      const response = await this.$http.get('/patient-api/webapi/user/list-medical-card', {
        params: {
          access_token: Cookies.get('token'),
          hospital_id: hospitalId,
        },
        headers: {
          Authorization: `Bearer ${Cookies.get('token')}`,
        },
      });
      const arr = response.list;
      for (let i = 0; i < arr.length; i += 1) {
        if (id === arr[i].id) {
          this.name = arr[i].name;
          this.gender = arr[i].sex;
          this.idNumber = arr[i].id_card_code;
          this.phone = arr[i].phone;
          this.card = arr[i].medical_card_id;
          this.hospital = arr[i].hospital_flag;
        }
      }
    },
    // 取消绑定就诊卡
    async unbindCard() {
      const hospitalId = this.$route.query.hospital;
      const params = {
        medical_card_id: this.card,
        hospital_id: hospitalId
      };
      const url = `/patient-api/webapi/user/unbind-medical-card?hospital_id=${hospitalId}`;
      const config = {
        headers: {
          Authorization: `Bearer ${Cookies.get('token')}`,
        },
      };
      await this.$http.post(url, params, config);
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
  .info-container{
    margin-top:5px;
  }
  .info-border{
    border-bottom: 1px solid #dee2e6;
  }
</style>



// WEBPACK FOOTER //
// src/views/user/personal-data.vue